import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
import { watchEffect, ref } from 'vue';
export default {
  __name: 'index',
  props: {
    // 是否开启
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var isSwitch = ref(true);
    watchEffect(function () {
      isSwitch.value = props.modelValue;
    });
    var handleSwitch = function handleSwitch() {
      isSwitch.value = !isSwitch.value;
      emit('update:modelValue', isSwitch.value);
      emit('change', isSwitch.value);
      //
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "switch",
        onClick: handleSwitch
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([false, true], function (item, index) {
        return _createElementVNode("span", {
          key: index,
          class: _normalizeClass([isSwitch.value === item ? 'switch-handle' : '', 'switch-content'])
        }, [_renderSlot(_ctx.$slots, "switch-content", {}, function () {
          return [_createTextVNode(_toDisplayString(index === 0 ? '无' : '有'), 1)];
        })], 2);
      }), 64))]);
    };
  }
};